// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__i++JA","create-modal":"styles_create-modal__uJVrV"};